import React from 'react';
import {Avatar, Box, Sheet, useColorScheme} from '@mui/joy';
import java from './../images/java.png';
import flutter from './../images/flutter.png';
import react from './../images/react.png';
import spring from './../images/spring_boot.png';
import photoshop from './../images/icons8_adobe_photoshop_96px.png';
import './Photo.css';
import {motion} from 'framer-motion';
import {SummaryModel} from "../model/summary";

function Photo({profileLight, profileDark, animate = true, useAvatar = true}: {
    profileLight: string,
    profileDark: string,
    animate: Boolean,
    useAvatar: Boolean
}) {
    function random(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const {mode, setMode} = useColorScheme();
    const profileImage = mode === 'dark' ? profileDark : profileLight;
    let width = 0
    let height = 0;
    if (window.innerWidth <= 360) {
        width = 240;
        height = 240;
    } else if (window.innerWidth < 600) {
        width = 260;
        height = 260;
    } else if (window.innerWidth >= 600 && window.innerWidth < 720) {
        width = 280;
        height = 280;
    } else if (window.innerWidth >= 720 && window.innerWidth < 900) {
        width = 300;
        height = 300;
    } else if (window.innerWidth > 900) {
        width = 320;
        height = 320;
    } else if (window.innerWidth > 1080) {
        width = 360;
        height = 360;
    }
    return (
        <Sheet sx={{borderRadius:16, maxWidth: width, maxHeight: height, width: width, height: height,}}>

            {animate && (
                <>
                    <motion.div
                        className='animate'
                        style={{
                            width: 32,
                            height: 32,
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        }}
                        initial={{opacity: 1, scale: 0.8}}
                        animate={{
                            opacity: 1, scale: 1.3
                        }}
                        transition={{repeat: Infinity, repeatType: "reverse", duration: 10}}
                    >
                        <Avatar
                            className='java'
                            variant='plain'
                            size='lg'
                            src={java}
                        />
                    </motion.div>
                    <motion.div
                        className='animate'
                        style={{
                            width: 24,
                            height: 24,
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                        }}
                        animate={{rotate: 360}}
                        transition={{repeat: Infinity, duration: 15, bounce: 0.6}}
                    >
                        <Avatar className='spring' variant='plain' size='sm' src={spring}/>
                    </motion.div>
                    <motion.div
                        className='animate'
                        style={{
                            width: 16,
                            height: 16,
                            position: 'absolute',
                            bottom: 50,
                            left: 0,
                        }}
                        initial={{opacity: 0.3, x: 0.5, y: 0.5, scale: 0.1}}
                        animate={{
                            rotate: 45,
                            scale: 0.8,
                            opacity: 0.5,
                        }}
                        transition={{opacity: 1, repeat: Infinity, duration: 5}}
                    >
                        <Avatar className='flutter' variant='plain' size='sm' src={flutter}/>
                    </motion.div>
                    <motion.div
                        className='animate'
                        style={{
                            width: 24,
                            height: 24,
                            position: 'absolute',
                            right: 0,
                        }}
                        animate={{rotate: 360}}
                        transition={{repeat: Infinity, duration: 15}}
                    >
                        <Avatar className='react' variant='plain' size='lg' src={react}/>
                    </motion.div>
                </>
            )}

            <Avatar color='primary' variant={useAvatar ? 'outlined' : 'plain'} sx={{maxWidth: width, maxHeight: height, width: width, height: height,}}>
                <Box component="img" src={profileImage} width={{xs: "103%", sm: '103%', md: "330px", lg: '330px', xl: '370'}}/>
            </Avatar>
        </Sheet>
    )
        ;
}

export default Photo;
